import React from "react";
import Select from "react-select";

Array.prototype.inArray = function(comparer) {
    for (var i = 0; i < this.length; i++) {
        if (comparer(this[i])) return true;
    }
    return false;
};

Array.prototype.pushIfNotExist = function(element, comparer) {
    if (!this.inArray(comparer)) {
        this.push(element);
    }
};

export const SelectField = ({
    options,
    field,
    form,
    multiple,
    placeholder,
    className,
    id,
    onBlur
}) => {
    function prepareValue(options, field, multiple) {
        if (Array.isArray(options)) {
            return options.map(option => option.value);
        }

        return options.value;
    }

    return (
        <Select
            options={options}
            className={className}
            name={field.name}
            inputId={id}
            value={
                options
                    ? options.find(option => option.value === field.value)
                    : null
            }
            styles={{
                control: (provided, state) => {
                    if (form.errors[field.name] && form.touched[field.name]) {
                        provided.borderColor = "red";
                        return provided;
                    }
                    provided.borderColor = "grey";
                    return provided;
                },
                placeholder: (provided, state) => {
                    provided.color = "var(--text-color)";
                    return provided;
                }
            }}
            classNamePrefix="select"
            isMulti={multiple}
            placeholder={placeholder}
            onChange={option => {
                form.setFieldValue(
                    field.name,
                    prepareValue(option, field, multiple)
                );
                setTimeout(() => {
                    form.validateForm();
                });
            }}
            onBlur={() => {
                form.setFieldTouched(field.name, true);
            }}
            clearValue={field.onReset}
        />
    );
};
